module.exports = __webpack_public_path__ + "img/checkmark.d338b94e.svg";